/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VulnerabilityScannerMappingUpsertRequest
 */
export interface VulnerabilityScannerMappingUpsertRequest {
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityScannerMappingUpsertRequest
     */
    scannerType?: VulnerabilityScannerMappingUpsertRequestScannerTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityScannerMappingUpsertRequest
     */
    scannerId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof VulnerabilityScannerMappingUpsertRequest
     */
    cveIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityScannerMappingUpsertRequest
     */
    mappingVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityScannerMappingUpsertRequest
     */
    mappingSource?: string;
}


/**
 * @export
 */
export const VulnerabilityScannerMappingUpsertRequestScannerTypeEnum = {
    QualysQid: 'QUALYS_QID',
    NessusPlugin: 'NESSUS_PLUGIN',
    MdeFinding: 'MDE_FINDING',
    Generic: 'GENERIC'
} as const;
export type VulnerabilityScannerMappingUpsertRequestScannerTypeEnum = typeof VulnerabilityScannerMappingUpsertRequestScannerTypeEnum[keyof typeof VulnerabilityScannerMappingUpsertRequestScannerTypeEnum];


/**
 * Check if a given object implements the VulnerabilityScannerMappingUpsertRequest interface.
 */
export function instanceOfVulnerabilityScannerMappingUpsertRequest(value: object): value is VulnerabilityScannerMappingUpsertRequest {
    return true;
}

export function VulnerabilityScannerMappingUpsertRequestFromJSON(json: any): VulnerabilityScannerMappingUpsertRequest {
    return VulnerabilityScannerMappingUpsertRequestFromJSONTyped(json, false);
}

export function VulnerabilityScannerMappingUpsertRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): VulnerabilityScannerMappingUpsertRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'scannerType': json['scannerType'] == null ? undefined : json['scannerType'],
        'scannerId': json['scannerId'] == null ? undefined : json['scannerId'],
        'cveIds': json['cveIds'] == null ? undefined : json['cveIds'],
        'mappingVersion': json['mappingVersion'] == null ? undefined : json['mappingVersion'],
        'mappingSource': json['mappingSource'] == null ? undefined : json['mappingSource'],
    };
}

export function VulnerabilityScannerMappingUpsertRequestToJSON(json: any): VulnerabilityScannerMappingUpsertRequest {
    return VulnerabilityScannerMappingUpsertRequestToJSONTyped(json, false);
}

export function VulnerabilityScannerMappingUpsertRequestToJSONTyped(value?: VulnerabilityScannerMappingUpsertRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'scannerType': value['scannerType'],
        'scannerId': value['scannerId'],
        'cveIds': value['cveIds'],
        'mappingVersion': value['mappingVersion'],
        'mappingSource': value['mappingSource'],
    };
}

